import defaults from './default.constants';

export const settingsConstants = {
  ...defaults.rsf('get', 'settings'),
  ...defaults.rsf('update', 'settings'),
};
